import React, { useState, useEffect } from 'react';
import { TextField, MenuItem, InputAdornment, IconButton } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import ClearIcon from '@mui/icons-material/Clear';

// List of country codes with formats
const countryFormats = {
    MX: { code: '+52', format: 'XX XXXX XXXX' }, // México
    // US: { code: '+1', format: '(XXX) XXX-XXXX' }, // USA
};

export const PhoneInput = ({
    value,
    onChange,
    error = '',
    helperText = '',
}) => {
    const [country, setCountry] = useState('MX');
    const [phoneNumber, setPhoneNumber] = useState(value || '');

    useEffect(() => {
        // Update phoneNumber state when value prop changes
        setPhoneNumber(value ? formatPhoneNumber(value, country) : '');
    }, [value, country]);

    // Format the phone number based on the selected country
    const formatPhoneNumber = (number, countryCode) => {
        let cleaned = ('' + number).replace(/\D/g, '');
        const countryFormat = countryFormats[countryCode].format;
        let result = '';

        let index = 0;
        for (let char of countryFormat) {
            if (char === 'X') {
                if (index < cleaned.length) {
                    result += cleaned[index];
                    index++;
                }
            } else {
                result += char;
            }
        }

        return result;
    };

    // Handle country change
    const handleCountryChange = event => {
        setCountry(event.target.value);
        setPhoneNumber('');
        onChange('');
    };

    // Handle phone number change
    const handlePhoneNumberChange = event => {
        const input = event.target.value;

        // Allow the field to remain empty without applying formatting
        if (input === '') {
            setPhoneNumber('');
            onChange('');
        } else {
            const formattedNumber = formatPhoneNumber(input, country);
            setPhoneNumber(formattedNumber);
            onChange(formattedNumber);
        }
    };

    // Get the border color based on the validation state
    const getBorderColor = fieldError => {
        return fieldError ? 'red' : phoneNumber ? '#0D6EFD' : '';
    };

    // Allow clearing the number
    const handleClear = () => {
        setPhoneNumber('');
        onChange('');
    };

    return (
        <TextField
            label="Teléfono"
            value={phoneNumber}
            onChange={handlePhoneNumberChange}
            error={!!error}
            helperText={helperText || error}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <TextField
                            select
                            value={country}
                            onChange={handleCountryChange}
                            variant="standard"
                            sx={{
                                width: '60px',
                                marginRight: '10px',
                                '& .MuiSelect-select': {
                                    paddingRight: '10px',
                                },
                            }}
                        >
                            {Object.keys(countryFormats).map(countryCode => (
                                <MenuItem key={countryCode} value={countryCode}>
                                    {countryFormats[countryCode].code}
                                </MenuItem>
                            ))}
                        </TextField>
                        <PhoneIcon />
                    </InputAdornment>
                ),
                endAdornment: (
                    <InputAdornment position="end">
                        {phoneNumber && (
                            <IconButton onClick={handleClear}>
                                <ClearIcon />
                            </IconButton>
                        )}
                    </InputAdornment>
                ),
            }}
            sx={{
                '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                        borderColor: getBorderColor(error),
                    },
                    '&.Mui-focused fieldset': {
                        borderColor: getBorderColor(error),
                    },
                },
            }}
            fullWidth
        />
    );
};
